import { useMemo } from 'react';
import { CustomVizHookStatus } from 'apps/sigma2-ui/src/lib/custom-viz/types';

export const useHiringCopilotCanAnalyze = ({
  status,
  selectedDepartments,
  selectedRoles,
  selectedLocations,
  selectedEndDate,
  selectedStartDate,
}: {
  status: CustomVizHookStatus;
  selectedDepartments: string[];
  selectedRoles: string[];
  selectedLocations: string[];
  selectedStartDate: Date | undefined;
  selectedEndDate: Date | undefined;
}) => {
  return useMemo(() => {
    return (
      status === 'waiting-for-user' &&
      selectedDepartments.length !== 0 &&
      selectedRoles.length !== 0 &&
      selectedLocations.length !== 0 &&
      !!selectedStartDate &&
      !!selectedEndDate
    );
  }, [
    selectedDepartments.length,
    selectedEndDate,
    selectedLocations.length,
    selectedRoles.length,
    selectedStartDate,
    status,
  ]);
};
